import React from 'react';
import { makeStyles } from '@material-ui/core';

import { useIntl } from 'ha/i18n';

import Button from 'ha/ui/next/Button';
import Grid from 'ha/ui/next/Grid';
import Divider from 'ha/ui/next/Divider';
import AuthModalActions from '../containers/AuthModalActions';

const useStyles = makeStyles(theme => ({
  grey: {
    color: theme.palette.grey[700],
  },
  divider: {
    height: '1rem',
    backgroundColor: theme.palette.grey[500],
    margin: '0 0.5rem',
  },
}));

export const UnauthenticatedNavigation: React.FC = () => {
  const { T } = useIntl();
  const classes = useStyles();

  return (
    <AuthModalActions>
      {({ onRegisterClick, onLoginClick }) => (
        <div className={classes.grey}>
          <Grid container alignItems="center">
            <Button
              data-test-locator="Login button"
              onClick={onLoginClick}
              variant="text"
              color="inherit"
            >
              {T('Log in')}
            </Button>
            <div className={classes.divider}>
              <Divider dividerProps={{ orientation: 'vertical' }} />
            </div>
            <Button
              data-test-locator="Register button"
              onClick={onRegisterClick}
              variant="text"
              color="inherit"
            >
              {T('Sign up')}
            </Button>
          </Grid>
        </div>
      )}
    </AuthModalActions>
  );
};

export default UnauthenticatedNavigation;
